// If you are adding a term to the ActionSubject glossary,
// please add a member of the Data team to your PR

export const ActionSubject = {
  accountEmail: 'accountEmail',
  app: 'app',
  atlassianSwitcherHeaderButton: 'atlassianSwitcherHeaderButton',
  avatar: 'avatar',
  banner: 'banner',
  board: 'board',
  boardBackground: 'boardBackground',
  boardOrganization: 'boardOrganization',
  boardPref: 'boardPref',
  boardVisibility: 'boardVisibility',
  button: 'button',
  card: 'card',
  cardCopy: 'cardCopy',
  checkbox: 'checkbox',
  collection: 'collection',
  comment: 'comment',
  commentsPermissions: 'commentsPermissions',
  description: 'description',
  drawer: 'drawer',
  drawerNavigationItem: 'drawerNavigationItem',
  dropdown: 'dropdown',
  dropdownItem: 'dropdownItem',
  edit: 'edit',
  editor: 'editor',
  email: 'email',
  embed: 'embed',
  error: 'error',
  feature: 'feature',
  icon: 'icon',
  inlineDialog: 'inlineDialog',
  input: 'input',
  invitation: 'invitation',
  invitationsPermissions: 'invitationsPermissions',
  label: 'label',
  link: 'link',
  list: 'list',
  location: 'location',
  mention: 'mention',
  menu: 'menu',
  menuItem: 'menuItem',
  modal: 'modal',
  mode: 'mode',
  notification: 'notification',
  onboarding: 'onboarding',
  organization: 'organization',
  overlay: 'overlay', // Use for info boxes, callouts within components
  panel: 'panel',
  payment: 'payment',
  pill: 'pill',
  powerUp: 'powerUp',
  prompt: 'prompt',
  primaryEmail: 'primaryEmail',
  radioButton: 'radioButton',
  reaction: 'reaction',
  reactionPicker: 'reactionPicker',
  save: 'save',
  search: 'search',
  secondaryEmail: 'secondaryEmail',
  select: 'select',
  session: 'session',
  shortcut: 'shortcut', // For keyboard shortcuts
  step: 'step',
  sticker: 'sticker',
  suggestion: 'suggestion',
  tab: 'tab',
  team: 'team',
  textField: 'textField',
  tile: 'tile',
  toggle: 'toggle',
  tooltip: 'tooltip',
  trial: 'trial',
  ui: 'ui', // this should only be used for stock "UI viewed"-type events
  upload: 'upload',
  upsell: 'upsell',
} as const;

export type ActionSubjectType = typeof ActionSubject[keyof typeof ActionSubject];

export const isValidActionSubject = (a: ActionSubjectType) => {
  const validSources = Object.values(ActionSubject);
  return validSources.includes(a);
};
